<template>
    <div class="card">
        <div class="card-body">
            <form name="mainForm"  @submit.prevent="onSubmit">
                <h4 class="card-title">
                    {{ title }}
                    <button type="submit" class="btn btn-success float-right text-uppercase"><i v-if="loader" class="zmdi zmdi-refresh zmdi-hc-fw rotating"></i> {{ $t('LBL_SAVE') }}</button>
                </h4>
                <div class="row">
                    <div :class="{'col-sm-12': field.consent, 'col-sm-6': !field.consent}" v-for="field in mainFields">
                        <component :is="getComponent(field)" v-bind="field" v-model="field.value"></component>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import BaseField from '@/components/form_elements/Base'
    import TextAreaField from '@/components/form_elements/TextArea'
    import SwitchField from '@/components/form_elements/Switch'
    import PicklistField from '@/components/form_elements/Picklist'
    import DetailField from '@/components/form_elements/Detail'

    export default {
        data: function() {
            return {
                loader: false,
                componentInfo: {}
            }
        },

        props: {
            title: {default: 'Main Fields'},
            mainFields: {type: Array, default: []},
        },

        components: {
            'base-field': BaseField,
            'textarea-field': TextAreaField,
            'picklist-field': PicklistField,
            'switch-field': SwitchField,
            'detail-field': DetailField
        },

        $_veeValidate: { validator: "new" },

        methods: {

            getComponent(fieldInfo){
                if(!fieldInfo.editable){
                    return 'detail-field'
                }

                switch (fieldInfo.type){
                    case 'picklist':
                    case 'multipicklist':
                        return 'picklist-field'
                    case 'boolean':
                        return 'switch-field'
                    case 'text':
                        return 'textarea-field'
                    default:
                        return 'base-field'
                }
            },

            async onSubmit() {
                await this.$validator.validateAll()

                if (!this.errors.any() && !this.loader) {
                    this.loader = true
                    var response = await Api.update($('form', this.$el).serializeFormData())
                    this.loader = false
                    if(response.success){
                        AppHelper.notify(this.$t('LBL_SAVE_DONE'), 'info')
                    }
                    else{
                        AppHelper.notify('Error occurred', 'warning')
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/MainForm.vue